// 清除cookie
const clearCookie = () => {
  // eslint-disable-next-line no-useless-escape
  const keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  const href = window.location.hostname.split('.');
  href.shift();
  const domain = `.${href.join('.')}`;
  const arr = domain.split(':');
  const delDomain = arr[0].indexOf('/') === -1 ? arr[0] : arr[0].substr(0, arr[0].length - 1);

  if (keys) {
    keys.forEach((item) => {
      const exp = new Date();
      exp.setTime(exp.getTime() - 1000000);
      document.cookie = `${item}=0;domain=${delDomain};path=/;expires=${exp.toGMTString()}`;
    });
  }
};
export default clearCookie;
